import { render, staticRenderFns } from "./huay-list-detail.vue?vue&type=template&id=7893b8b4&scoped=true&"
import script from "./huay-list-detail.vue?vue&type=script&lang=js&"
export * from "./huay-list-detail.vue?vue&type=script&lang=js&"
import style0 from "./huay-list-detail.vue?vue&type=style&index=0&id=7893b8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7893b8b4",
  null
  
)

export default component.exports